import ActionTypes from '../actions/actionTypes';
import InitialState from './initialState';

const countReducer = (state = InitialState.counts, action) => {
  switch (action.type) {
    case ActionTypes.PENDINGRELEASECOUNT_SUCCEEDED: {
      return {
        ...state,
        pendingReleaseCount: action.payload.pendingReleaseCount,
      };
    }
    case ActionTypes.UPDATE_PENDINGRELEASECOUNT: {
      return {
        pendingReleaseCount: state.pendingReleaseCount + action.payload.IncreaseWith,
      };
    }
    default: {
      return state;
    }
  }
};

export default countReducer;
